export class CurrencyData { 
 public static currencies: Array<[string,string]> = [
        /*0 - None*/['0', 'None'],
        /*1 - £*/['1', String.fromCharCode(163)],
        /*2 - $*/['2', String.fromCharCode(36)],
        /*3 - €*/['3', String.fromCharCode(8364)],
        /*4 - ¥*/['4', String.fromCharCode(165)],
        /*5 - ₱*/['5', String.fromCharCode(8369)],
        /*6 - Fr*/['6', String.fromCharCode(70) + String.fromCharCode(114)],
        /*7 - kr*/['7', String.fromCharCode(75) + String.fromCharCode(114)],
        /*8 - Turkish Lira*/['8', String.fromCharCode(8378)],
        /*9 - ￦*/['9', String.fromCharCode(8361)],
        /*10 - R*/['10', String.fromCharCode(82)],
        /*11 - Rs*/['11', String.fromCharCode(8360)],
        /*12 - ₹*/['12', String.fromCharCode(8377)],
        /*13 - ฿*/['13', String.fromCharCode(3647)],
        /*14 - ₪  */['14', String.fromCharCode(8362)],
        /*15 - TZS  */['15', 'TZS'],
        /*16 - CHF  */['16', 'CHF'],
        /*17 - Naira */['17', String.fromCharCode(8358)],
        /*18 - Dirham*/['18', 'DH'],
        /*19 - Ringgit*/['19', 'RM'],
        /*20 - Brazil Real*/['20', String.fromCharCode(82) + String.fromCharCode(36)],
        /*21 - Omani Rial*/['21', 'OMR'],
        /*22 - Polish złoty*/['22', 'zł'],
        /*23 - Iranian Rial*/['23', 'IRR']
    ];

    public static arraySearchByIdx(array: Array<[string, string]>, param: string) {

        for (var i = 0; i < array.length; i++) {
            if (array[i].indexOf(param) !== -1) {
                return array[i][1];
            }
        }

        return -1;

    }
}